/**
 * Branch-scoped sourcing (+ auction) tags — invalidate on `active_branch` (X-Branch).
 * Includes aux lists via `*AllListsWithSameResponseStructure` (favourite, to-buy, etc.).
 * Not included: filter presets, relative filters, price map.
 * Keep aligned with `providesTags` in sourcing/api.ts and sourcingAuction/api.ts.
 */
export const BRANCH_SOURCING_CACHE_TAGS = [
  'SourcingVehicleList',
  'SourcingAllListsWithSameResponseStructure',
  'SourcingVehicleDetail',
  'SourcingVehicleCosts',
  'SourcingAuctionList',
  'SourcingAuctionAllListsWithSameResponseStructure',
  'SourcingAuctionDetail',
] as const;
